export const EDITOR_CONNECTED: string = 'EDITOR_CONNECTED';
export const EDITOR_DISCONNECTED: string = 'EDITOR_DISCONNECTED';
export const RUN_CODE: string = 'RUN_CODE';
export const REQUEST_START: string = 'REQUEST_START';
export const REQUEST_END: string = 'REQUEST_START';

export const SELECT_LANGUAGE: string = 'SELECT_LANGUAGE';
export const CHANGE_CODE: string = 'CHANGE_CODE';
export const RESET_CODE: string = 'RESET_CODE';
